import * as R from "ramda";

export const leaveInterceptor = R.evolve({
  answer: R.trim
});
